import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Helmet from "react-helmet"
import Footer from "./footer"
import CookieConsent from "./CookieConsent"

const buildLocalBusinessSchema = (siteUrl) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: process.env.GATSBY_siteCompanyName || "",
  email: process.env.GATSBY_siteEmail || "",
  url: siteUrl || process.env.GATSBY_siteWebSite || "",
})

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
          keywords
          siteUrl
        }
      }
      allContentfulEnlaces {
        edges {
          node {
            title
            url
          }
        }
      }
    }
  `)

  return (
    <div>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          { name: "description", content: data.site.siteMetadata.description },
          { name: "keywords", content: data.site.siteMetadata.keywords },
        ]}
      >
        <script type="application/ld+json">
          {JSON.stringify(
            buildLocalBusinessSchema(data.site.siteMetadata.siteUrl)
          )}
        </script>
      </Helmet>
      {children}
      <Footer data={data}>
        El diseño y servicio online para {process.env.GATSBY_siteCompanyName} es
        realizado por {process.env.GATSBY_platformCompanyName}, envia un{" "}
        <a
          href={`mailto:${
            process.env.GATSBY_platformEmail || "powering2u@gmail.com"
          }`}
        >
          Email
        </a>{" "}
        para mas informacion.
      </Footer>
      <CookieConsent />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
